import { createContext } from 'react';

export const InvoiceHubContext = createContext({
  fetchMoreInvoices: () => {},
});
